module.exports = __webpack_public_path__ + "static/media/integrations.a7a2eaa4.svg";